import { format } from "date-fns";

class LocalStorageService {
  setTokens(token: string, refreshToken: string, isTokenExpired?: boolean) {
    localStorage.setItem("token", token);
    localStorage.setItem("refreshToken", refreshToken);
    localStorage.setItem("isTokenExpired", isTokenExpired ? "1" : "");
  }

  clearTokens() {
    localStorage.setItem("isTokenExpired", "");
    localStorage.setItem("token", "");
    localStorage.setItem("refreshToken", "");
    localStorage.setItem("updateBannerDate", "");
    localStorage.setItem("attemptsErrorToken", "");
    localStorage.setItem("tutorialName", "");
  }

  getToken() {
    return localStorage.getItem("token");
  }

  getRefreshToken() {
    return localStorage.getItem("refreshToken") || "";
  }

  setTokenExpired() {
    localStorage.setItem("isTokenExpired", "1");
  }

  isTokenExpired() {
    return localStorage.getItem("isTokenExpired");
  }

  removeTokenExpired() {
    return localStorage.removeItem("isTokenExpired");
  }

  setAttemptsErrorToken(value: string) {
    localStorage.setItem("attemptsErrorToken", value);
  }

  getAttemptsErrorToken() {
    return localStorage.getItem("attemptsErrorToken") || "0";
  }

  incAttemptsErrorToken() {
    localStorage.setItem(
      "attemptsErrorToken",
      String(Number(localStorage.getItem("attemptsErrorToken") || "0") + 1),
    );
  }

  setUpdateBannerDate() {
    localStorage.setItem("updateBannerDate", format(new Date(), "yyyy-MM-dd"));
  }

  getUpdateBannerDate() {
    return localStorage.getItem("updateBannerDate");
  }

  setTutorialName(tutorialName: string) {
    localStorage.setItem("tutorialName", tutorialName);
  }

  getTutorialName() {
    return localStorage.getItem("tutorialName");
  }

  removeTutorialName() {
    return localStorage.removeItem("tutorialName");
  }

  setUploadLaterBannerDate() {
    localStorage.setItem(
      "uploadLaterBannerDate",
      format(new Date(), "yyyy-MM-dd"),
    );
  }

  getUploadLaterBannerDate() {
    return localStorage.getItem("uploadLaterBannerDate");
  }
}

export const localStorageService = new LocalStorageService();
